import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';

/*
**************************************************************************************************************
PROPS :
    ATTRIBUTS :
        string  errorMessage
        string  infoMessage
        string  successMessage
        string  warningMessage
    METHODES :
        void    onDismissErrorMessage()
        void    onDismissSuccessMessage()
        void    onDismissWarningMessage()
**************************************************************************************************************
*/

export class MessageBars extends Component {

    render = () => {
        return <Fragment>
            {this.props.successMessage && <div>
                <MessageBar
                    isMultiline={true}
                    messageBarType={MessageBarType.success}
                    onDismiss={this.props.onDismissSuccessMessage}
                >
                    {this.props.successMessage}
                </MessageBar>
            </div>}
            {this.props.infoMessage && <div>
                <MessageBar
                    isMultiline={true}
                    messageBarType={MessageBarType.info}
                >
                    {this.props.infoMessage}
                </MessageBar>
            </div>}
            {this.props.warningMessage && <div>
                <MessageBar
                    isMultiline={true}
                    messageBarType={MessageBarType.warning}
                    onDismiss={this.props.onDismissWarningMessage}
                >
                    {this.props.warningMessage}
                </MessageBar>
            </div>}
            {this.props.errorMessage && <div>
                <MessageBar
                    isMultiline={true}
                    messageBarType={MessageBarType.error}
                    onDismiss={this.props.onDismissErrorMessage}
                >
                    {this.props.errorMessage}
                </MessageBar>
            </div>}
        </Fragment>
    };

};

MessageBars.propTypes = {
    errorMessage: PropTypes.string,
    infoMessage: PropTypes.string,
    successMessage: PropTypes.string,
    warningMessage: PropTypes.string,
    onDismissErrorMessage: PropTypes.func,
    onDismissSuccessMessage: PropTypes.func,
    onDismissWarningMessage: PropTypes.func,
};

MessageBars.defaultProps = {
    errorMessage: "",
    infoMessage: "",
    successMessage: "",
    warningMessage: ""
};